import {TypedUseSelectorHook, useSelector} from 'react-redux';
import { TAppRootState } from '../../types';

export const useAppSelector: TypedUseSelectorHook<TAppRootState> = useSelector;
